var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5986 0C18.4753 0.00019974 20 1.56059 20 3.48047V10.9805C19.9998 12.9001 18.4752 14.4598 16.5986 14.46H3.40137C1.52487 14.4597 0.000248399 12.9001 0 10.9805V3.48047C0 1.5606 1.52471 0.000221139 3.40137 0H16.5986ZM1.91602 6.45996V10.9805C1.91626 11.8201 2.58059 12.4998 3.40137 12.5H16.5986C17.4194 12.4998 18.0837 11.8201 18.084 10.9805H18.0742V6.45996H1.91602ZM16.1094 9.50977C16.6372 9.50977 17.0674 9.95023 17.0674 10.4902C17.0673 11.0301 16.6372 11.4697 16.1094 11.4697H13.666C13.1382 11.4697 12.7081 11.0301 12.708 10.4902C12.708 9.95023 13.1382 9.50977 13.666 9.50977H16.1094ZM3.41113 1.95996C2.5902 1.96019 1.92578 2.64061 1.92578 3.48047V4.5C8.16342 4.39778 11.6415 4.31516 18.0938 4.5V3.48047C18.0938 2.64059 17.4294 1.96015 16.6084 1.95996H3.41113Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.64ba44f72dac56522baa43537bedad09.svg";
export { ForwardRef as ReactComponent };